import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Sidebar from '../Containers/sideBar';

class Homepage extends Component {
  render() {
    return (
      <div className="Homepage">
        <Sidebar></Sidebar>
        <span className="info-404">The resource requested is not found</span>
        <FontAwesomeIcon icon="shield-alt" />
      </div>
    );
  }
}

export default Homepage;